// schema
import * as ISchema from "@schema";
import { RelayProp, createFragmentContainer } from "react-relay";
// libraries
import * as React from "react";
// event-summary-attendees
import { eventSummaryRecurrenceFragments } from "./EventSummaryRecurrence.gql";
import { EventSummaryRow as s } from "./EventSummary.styles";
// util
import { EFlex, getFlexFromEvent } from "@util/event-tag.util";
import {
  getEventTime,
  getAutopilotTime,
} from "@clockwise/client-commons/src/util/event-recurrence";
// material-ui
import { Autorenew } from "@material-ui/icons";

interface IContainer {
  org: ISchema.IOrg;
  event: ISchema.IEvent;
  color?: string;
  selectedFlex?: EFlex; // a way to override w/e org tag may be on the event
  calendarId?: string;
}

interface IProps extends IContainer {
  relay: RelayProp;
}

interface IState {}

class EventSummaryRecurrenceCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {};
  }

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  public render() {
    const { event, color, selectedFlex } = this.props;

    const flexStringMap: { [key: string]: string } = {};

    (
      (event.eventFlexibilityErrorable?.__typename === "EventFlexibilityNewList" &&
        event.eventFlexibilityErrorable.list) ||
      []
    ).forEach(({ flex: flexKey, flexString }) => (flexStringMap[flexKey] = flexString));

    const currentFlex = getFlexFromEvent(event, undefined);

    let recurrence: string | undefined = flexStringMap[selectedFlex || currentFlex] ?? "";

    if (!recurrence) {
      const flex = getFlexFromEvent(event, true); // flexibility from org-tag
      const eventTime = getEventTime(event); // the current recurrence string for event
      const autopilotTime = getAutopilotTime(event, selectedFlex || flex); // recurrence string accounting for autopilot flex
      recurrence =
        selectedFlex === undefined && flex === EFlex.Pin
          ? eventTime
          : selectedFlex === EFlex.Pin
          ? eventTime
          : autopilotTime;
    }

    return (
      <div style={{ ...s.container }}>
        <Autorenew style={{ ...s.icon, color }} htmlColor={color || s.icon.color} />
        <div style={{ ...s.text, color: color || s.slate }}>{recurrence}</div>
      </div>
    );
  }
}

export const EventSummaryRecurrence = createFragmentContainer<IContainer>(
  EventSummaryRecurrenceCmpt,
  eventSummaryRecurrenceFragments,
);
